import { AutoCompleteOption } from "@asayinc/component-library";

export const SHARE_RANGE_ANALYSIS_TYPE_OPTIONS: AutoCompleteOption[] = [
  {
    name: "All Shareholders",
    id: "all_shareholders",
  },
  {
    name: "Not Voted Shareholders",
    id: "not_voted_shareholders",
  },
  {
    name: "Voted Shareholders",
    id: "voted_shareholders",
  },
];
